var _g, _g2, _path, _path2, _g3, _path3, _defs, _clipPath, _path4, _path5, _path6, _defs2, _clipPath2, _path7, _path8, _polygon, _path9, _polygon2, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "nodeJS-logo",
    enableBackground: "new 0 0 456 284",
    id: "Layer_1",
    viewBox: "0 0 456 284",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.953,279.054c-1.46,0-2.912-0.381-4.19-1.121l-13.339-7.892c-1.991-1.115-1.018-1.509-0.362-1.738   c2.657-0.922,3.195-1.135,6.031-2.743c0.295-0.166,0.687-0.103,0.992,0.076l10.247,6.084c0.372,0.206,0.896,0.206,1.237,0   l39.95-23.058c0.372-0.212,0.61-0.64,0.61-1.081v-46.103c0-0.451-0.239-0.872-0.62-1.101l-39.933-23.038   c-0.368-0.216-0.859-0.216-1.231,0l-39.923,23.045c-0.388,0.222-0.634,0.657-0.634,1.094v46.103c0,0.441,0.245,0.859,0.63,1.068   l10.944,6.323c5.938,2.969,9.573-0.528,9.573-4.041v-45.52c0-0.643,0.518-1.151,1.161-1.151h5.066c0.634,0,1.158,0.508,1.158,1.151   v45.52c0,7.925-4.316,12.47-11.829,12.47c-2.309,0-4.127,0-9.202-2.501l-10.476-6.031c-2.587-1.496-4.19-4.293-4.19-7.288v-46.103   c0-2.995,1.602-5.792,4.19-7.281l39.95-23.085c2.528-1.43,5.888-1.43,8.396,0l39.947,23.085c2.587,1.496,4.196,4.286,4.196,7.281   v46.103c0,2.995-1.609,5.782-4.196,7.288l-39.947,23.065C228.882,278.673,227.433,279.054,225.953,279.054z",
    fill: "#699F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.293,247.292c-17.482,0-21.144-8.024-21.144-14.755c0-0.64,0.514-1.151,1.155-1.151h5.165   c0.577,0,1.058,0.415,1.148,0.979c0.78,5.258,3.105,7.912,13.677,7.912c8.416,0,11.999-1.904,11.999-6.369   c0-2.574-1.015-4.485-14.095-5.766c-10.93-1.081-17.691-3.496-17.691-12.241c0-8.061,6.794-12.868,18.186-12.868   c12.798,0,19.131,4.442,19.933,13.972c0.03,0.328-0.086,0.644-0.305,0.889c-0.219,0.229-0.524,0.368-0.846,0.368h-5.185   c-0.537,0-1.012-0.381-1.121-0.902c-1.244-5.533-4.269-7.301-12.476-7.301c-9.189,0-10.257,3.201-10.257,5.599   c0,2.906,1.261,3.752,13.667,5.394c12.277,1.622,18.109,3.921,18.109,12.549C258.21,242.306,250.952,247.292,238.293,247.292z",
    fill: "#699F63"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295.899,198.941c0,4.236-3.463,7.699-7.699,7.699c-4.197,0-7.699-3.422-7.699-7.699   c0-4.359,3.586-7.701,7.699-7.701C292.356,191.24,295.899,194.582,295.899,198.941z M281.744,198.919   c0,3.586,2.892,6.479,6.435,6.479c3.586,0,6.479-2.954,6.479-6.479c0-3.584-2.932-6.436-6.479-6.436   C284.676,192.484,281.744,195.293,281.744,198.919z M285.307,194.622h2.976c1.018,0,3.015,0,3.015,2.282   c0,1.589-1.018,1.914-1.632,2.118c1.184,0.082,1.264,0.856,1.426,1.956c0.083,0.692,0.206,1.874,0.448,2.281h-1.831   c-0.043-0.406-0.328-2.607-0.328-2.728c-0.119-0.49-0.285-0.733-0.895-0.733h-1.506v3.461h-1.672v-8.637H285.307z M286.939,198.41   h1.343c1.098,0,1.304-0.773,1.304-1.221c0-1.183-0.816-1.183-1.264-1.183h-1.383L286.939,198.41L286.939,198.41z",
    fill: "#699F63"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.243,98.677c0-1.841-0.969-3.533-2.558-4.445L57.33,69.857c-0.716-0.421-1.519-0.64-2.332-0.674  c-0.073,0-0.378,0-0.438,0c-0.809,0.033-1.612,0.252-2.339,0.674L9.866,94.232c-1.579,0.912-2.561,2.604-2.561,4.445l0.093,65.635  c0,0.912,0.474,1.762,1.277,2.209c0.786,0.471,1.758,0.471,2.541,0l25.172-14.414c1.592-0.945,2.561-2.614,2.561-4.438v-30.665  c0-1.828,0.968-3.52,2.554-4.428l10.718-6.173c0.799-0.461,1.672-0.687,2.564-0.687c0.872,0,1.768,0.226,2.544,0.687l10.715,6.173  c1.586,0.909,2.558,2.601,2.558,4.428v30.665c0,1.824,0.982,3.503,2.564,4.438l25.165,14.414c0.789,0.471,1.775,0.471,2.558,0  c0.78-0.448,1.271-1.297,1.271-2.209L102.243,98.677z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306.04,8.451c-0.793-0.441-1.76-0.431-2.543,0.028c-0.781,0.46-1.262,1.299-1.262,2.206v65  c0,0.639-0.342,1.231-0.894,1.551c-0.554,0.32-1.237,0.32-1.792,0l-10.608-6.112c-1.583-0.912-3.53-0.91-5.112,0.002l-42.372,24.453  c-1.584,0.914-2.559,2.603-2.559,4.43v48.916c0,1.828,0.975,3.516,2.558,4.432l42.37,24.471c1.584,0.914,3.534,0.914,5.118,0  l42.376-24.471c1.583-0.915,2.558-2.604,2.558-4.432V26.989c0-1.854-1.003-3.565-2.624-4.469L306.04,8.451z M302.109,132.853  c0,0.456-0.244,0.879-0.64,1.106l-14.548,8.386c-0.395,0.227-0.882,0.227-1.277,0l-14.548-8.386c-0.396-0.227-0.64-0.65-0.64-1.106  v-16.799c0-0.456,0.244-0.879,0.639-1.108l14.548-8.403c0.396-0.229,0.884-0.229,1.28,0l14.548,8.403  c0.395,0.229,0.639,0.652,0.639,1.108L302.109,132.853L302.109,132.853z",
    fill: "#ffffff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M447.131,115.615c1.576-0.915,2.546-2.601,2.546-4.424V99.337c0-1.823-0.97-3.51-2.548-4.425L405.03,70.469   c-1.584-0.921-3.54-0.922-5.127-0.007l-42.356,24.453c-1.583,0.914-2.558,2.602-2.558,4.43v48.903c0,1.839,0.987,3.536,2.584,4.445   l42.093,23.985c1.552,0.886,3.455,0.896,5.017,0.028l25.46-14.151c0.808-0.449,1.311-1.297,1.315-2.219   c0.007-0.922-0.484-1.776-1.284-2.236l-42.625-24.465c-0.796-0.456-1.285-1.304-1.285-2.22v-15.326c0-0.914,0.487-1.76,1.28-2.216   l13.266-7.648c0.789-0.456,1.765-0.456,2.554,0l13.273,7.648c0.793,0.456,1.28,1.302,1.28,2.216v12.058   c0,0.916,0.49,1.762,1.282,2.218c0.793,0.458,1.77,0.454,2.561-0.005L447.131,115.615z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.842,113.324c0.304-0.176,0.678-0.176,0.982,0l8.13,4.69c0.304,0.176,0.491,0.499,0.491,0.851v9.388   c0,0.352-0.187,0.675-0.491,0.851l-8.13,4.69c-0.304,0.176-0.678,0.176-0.982,0l-8.124-4.69c-0.304-0.176-0.491-0.499-0.491-0.851   v-9.388c0-0.352,0.187-0.675,0.491-0.851L401.842,113.324z",
    fill: "#699F63"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "XMLID_2_",
    x1: 187.702,
    x2: 149.6371,
    y1: 199.2852,
    y2: 121.6329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    style: {
      stopColor: "#418B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    style: {
      stopColor: "#419637"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    style: {
      stopColor: "#3FA92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FAE2A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.12,70.717c-1.574-0.909-3.514-0.909-5.087,0l-42.134,24.314    c-1.576,0.909-2.546,2.588-2.546,4.408v48.666c0,1.818,0.97,3.497,2.544,4.408l42.134,24.334c1.575,0.909,3.515,0.909,5.091,0    l42.124-24.334c1.574-0.91,2.543-2.59,2.543-4.408V99.437c0-1.818-0.97-3.497-2.545-4.406L173.12,70.717z",
    fill: "url(#XMLID_2_)",
    id: "XMLID_143_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.12,70.717c-1.574-0.909-3.514-0.909-5.087,0l-42.134,24.314c-1.576,0.909-2.546,2.588-2.546,4.408     v48.666c0,1.818,0.97,3.497,2.544,4.408l42.134,24.334c1.575,0.909,3.515,0.909,5.091,0l42.124-24.334     c1.574-0.91,2.543-2.59,2.543-4.408V99.437c0-1.818-0.97-3.497-2.545-4.406L173.12,70.717z",
    id: "SVGID_1_"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_1_"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.944,70.717l-42.222,24.314C124.146,95.94,123,97.619,123,99.439v48.666     c0,1.203,0.514,2.339,1.313,3.238l47.44-81.152C170.479,69.877,169.101,70.049,167.944,70.717z",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.988,177.339c0.41-0.113,0.81-0.275,1.186-0.492l42.177-24.334c1.574-0.91,2.649-2.59,2.649-4.408     V99.437c0-1.338-0.598-2.598-1.54-3.534L171.988,177.339z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    x1: 164.1574,
    x2: 270.9646,
    y1: 158.647,
    y2: 237.5619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    style: {
      stopColor: "#41873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    style: {
      stopColor: "#6CC04A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.327,95.031l-42.252-24.314c-0.417-0.241-0.863-0.413-1.322-0.526l-47.44,81.152     c0.409,0.46,0.888,0.861,1.42,1.169l42.323,24.334c1.199,0.692,2.624,0.854,3.931,0.492l44.473-81.436     C216.122,95.568,215.743,95.271,215.327,95.031z",
    fill: "url(#SVGID_3_)"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.12,70.717c-1.574-0.909-3.514-0.909-5.087,0l-42.134,24.314c-1.576,0.909-2.546,2.588-2.546,4.408     v48.666c0,1.818,0.97,3.497,2.544,4.408l42.134,24.334c1.575,0.909,3.515,0.909,5.091,0l42.124-24.334     c1.574-0.91,2.543-2.59,2.543-4.408V99.437c0-1.818-0.97-3.497-2.545-4.406L173.12,70.717z",
    id: "SVGID_4_"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_4_"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_5_)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218,148.105V99.437c0-1.818-1.098-3.497-2.673-4.406l-42.252-24.314c-0.485-0.28-1.011-0.463-1.551-0.571     l46.317,79.128C217.94,148.895,218,148.505,218,148.105z",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.722,95.031C124.146,95.94,123,97.619,123,99.439v48.666c0,1.818,1.16,3.497,2.733,4.408l42.323,24.334     c0.995,0.574,2.146,0.784,3.256,0.632l-45.337-82.594L125.722,95.031z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_6_",
    x1: 121.8623,
    x2: 219.2793,
    y1: 226.1655,
    y2: 226.1655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_6_)",
    points: "166.627,61.779 166.047,62.11 166.821,62.11    "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_7_",
    x1: 121.8623,
    x2: 219.2793,
    y1: 164.3476,
    y2: 164.3476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.351,152.513c1.228-0.71,2.144-1.891,2.491-3.238l-46.317-79.128     c-1.209-0.241-2.492-0.058-3.581,0.571l-41.968,24.168l45.337,82.594c0.647-0.088,1.281-0.298,1.861-0.632L215.351,152.513z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_8_",
    x1: 121.8623,
    x2: 219.2793,
    y1: 136.5375,
    y2: 136.5375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_8_)",
    points: "219.279,151.73 219,151.253 219,151.892    "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_9_",
    x1: 121.8623,
    x2: 219.2793,
    y1: 123.968,
    y2: 123.968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919,
    style: {
      stopColor: "#6CC04A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    style: {
      stopColor: "#66B848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      stopColor: "#54A044"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    style: {
      stopColor: "#41873F"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.351,152.513l-42.177,24.334c-0.58,0.335-1.214,0.544-1.861,0.632l0.84,1.53L219,151.892     v-0.639l-1.158-1.978C217.495,150.622,216.579,151.802,215.351,152.513z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 -1 0 288.11)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_10_",
    x1: 233.4718,
    x2: 173.3912,
    y1: 201.5876,
    y2: 79.0232
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    style: {
      stopColor: "#418B3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    style: {
      stopColor: "#419637"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    style: {
      stopColor: "#3FA92D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FAE2A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.351,152.513l-42.177,24.334c-0.58,0.335-1.214,0.544-1.861,0.632l0.84,1.53L219,151.892     v-0.639l-1.158-1.978C217.495,150.622,216.579,151.802,215.351,152.513z",
    fill: "url(#SVGID_10_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs);
export default __webpack_public_path__ + "static/media/nodeJS.2090e52a.svg";
export { ForwardRef as ReactComponent };